module.exports = __webpack_public_path__ + "img/van-blue.278d242c.svg";